var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.927734,
    y: 1,
    width: 28.9088,
    height: 29.9997,
    rx: 8.72717,
    stroke: "#0D0D0D",
    strokeWidth: 1.76469
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6213 15.8413C18.4379 15.8413 20.7212 13.558 20.7212 10.7415C20.7212 7.92489 18.4379 5.6416 15.6213 5.6416C12.8048 5.6416 10.5215 7.92489 10.5215 10.7415C10.5215 13.558 12.8048 15.8413 15.6213 15.8413Z",
    stroke: "#0D0D0D",
    strokeWidth: 1.76469,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3825 26.0412C24.3825 22.0939 20.4556 18.9014 15.6209 18.9014C10.7863 18.9014 6.85938 22.0939 6.85938 26.0412",
    stroke: "#0D0D0D",
    strokeWidth: 1.76469,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.10c228fa3918d3c6d53164e0806d5fc4.svg";
export { ForwardRef as ReactComponent };